export default "__VITE_ASSET__WNHrtFtI__"